<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>
        <div class="d-flex align-items-center">
            <div class="card flex-fill">
                <b-tabs small card>
                    <b-tab active class="p-2">
                        <template #title>
                            <b-icon icon="calendar-date" variant="primary"></b-icon>
                            <span class="ms-2">Filtrar por fecha de creación</span>
                        </template>
                        <DateFilter @filter="fetchMeetings" :initialRange="dateRange" :hideClear="true">
                        </DateFilter>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="col-md-2 ms-3 d-flex">
                <div class="align-items-center flex-grow-1">
                    <div class="h-100 d-flex flex-column justify-content-center">
                        <PrintWindow class="w-100 mb-2" tooltip="Imprimir tabla" title="Reporte de Reuniones">
                            <CompanyInformationCard :title="reportTitle" class="mb-3"></CompanyInformationCard>
                            <MeetingReportTable :items="meetings" />
                        </PrintWindow>
                        <MeetingReportExcel class="mt-2" :items="meetings" />
                    </div>
                </div>
            </div>
        </div>

        <MeetingReportTable class="m-3" :items="meetings"></MeetingReportTable>
    </div>
</template>

<script>
import DateFilter from '@/components/shared/Filters/Date-filter.vue'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import MeetingReportTable from './MeetingReport/Meeting-report-table.vue'
import PrintWindow from '@/components/shared/Print-window.vue'
import { mapActions } from 'vuex'
import { addDays, formatDateInput} from '@/plugins/complianceScripts/index.js'
import CompanyInformationCard from '@/components/shared/Company-information-card.vue'
import MeetingReportExcel from './MeetingReport/Meeting-report-excel.vue'

export default {
    name: 'MeetingReport',

    components: {
        DateFilter,
        AlertDismiss,
        MeetingReportTable,
        PrintWindow,
        CompanyInformationCard,
        MeetingReportExcel
    },

    data() {
        const today = new Date()
        const sevenDaysAgo = addDays(today, -7)

        return {
            dateRange: {
                startDate: formatDateInput(sevenDaysAgo) + 'T00:00:00.000Z',
                endDate: formatDateInput(today) + 'T23:59:59.999Z'
            },
            meetings: null
        }
    },

    computed: {
        reportTitle() {
            return `Reuniones programadas: (${this.formatDateOnly(this.dateRange.startDate)} - ${this.formatDateOnly(this.dateRange.endDate)})`;
        },
    },

    async mounted() {
        await this.fetchMeetings(this.dateRange)
    },

    methods: {
        ...mapActions(['getAllMeetingsByDate', 'allCommentsMeeting']),

        formatDateOnly(date) {
            if (!date) return '';
            const fechaHora = new Date(date);
            return fechaHora.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        },

        async fetchMeetings(range) {
            this.dateRange = range;

            let result = await this.getAllMeetingsByDate({
                initDate: range.startDate,
                finalDate: range.endDate
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            let meetingsPromise = result.data.map(async meeting => {
                let result = await this.allCommentsMeeting({ meetingId: meeting.id });
                if (!result.isError) {
                    meeting.comments = result.data;
                } else {
                    this.$refs.alertDismiss.showAlert(`Error descargando vistas ${meeting.id}: ${result.message}`, "danger");
                }
                return meeting;
            });
            
            this.meetings = await Promise.all(meetingsPromise);
        }
        
    }
}
</script>

<style></style>